import { PageLayout } from '@/global/components';
import { Breadcrumbs } from '@/lib/Breadcrumbs';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import {
  CreateCampaignCard,
  HomeAudienceSection,
  HomeContentSection,
  HomeDataSourceSection,
  HomeDestinationsSection,
  HomeIllustrationCard,
  HomePageAlert,
} from './parts';

export const HomePage: FC = () => {
  return (
    <PageLayout className='gap-12 @container/page'>
      <header className='grid'>
        <Breadcrumbs items={[]} className='bg-primary-background' />
        <HomePageAlert />
      </header>
      <div className='grid grid-cols-1 gap-5 lg:grid-cols-12 lg:gap-12'>
        <HomeContentSection className='lg:col-span-7 xl:col-span-6' />
        <div className='flex flex-col lg:col-span-5 xl:col-span-6'>
          <HomeIllustrationCard />
          <CreateCampaignCard />
        </div>
      </div>
      <div
        className={twMerge(
          'grid grid-cols-[repeat(2,minmax(15rem,1fr))] gap-2.5 p-2.5 ',
          '@5xl/page:grid-cols-[minmax(10rem,25%)_minmax(30rem,1fr)_minmax(12rem,25%)]'
        )}
      >
        <HomeDataSourceSection />
        <HomeAudienceSection />
        <HomeDestinationsSection />
      </div>
    </PageLayout>
  );
};
